module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addBankInsuranceForClient":"Add bank insurance for client"},"al":{"addBankInsuranceForClient":"Shto Sigurim Bankar për klientin"}}')
  delete Component.options._Ctor
}
